import {
  configureLinesChartValidates,
  configureDataValidate,
  resultsetWithFields,
} from 'vlcishared';
import { yAxisFormat, configureDataLine, calculateXAxisStart } from '../common';
import { DEFAULT_LANGUAGE } from '../common-language';
import { TEXTS_GAUGE_YEAR } from './texts';
import { COLORS } from '../constants/constants';

export function echartAccessosCiutat(vis, datos) {
  const color = COLORS.slice();
  const datosArray = datos.resultset || datos;

  // Obtenemos los datos ordenados
  const cleanData = configureDataLine(datosArray, color, false);
  const date = cleanData[1];
  const xAxisData = Array.from(date.values());
  const legendData = cleanData[2];
  const datazoomStart = calculateXAxisStart(date.size);

  // Obtenemos los datos para formar la serie
  const resultSet = resultsetWithFields(datos);
  const kpiValidList = [
    'KpiValid-30-Accesos-Ciudad-Coches',
    'KpiValid-365-Accesos-Ciudad-Coches',
  ];
  const kpiInvalidList = ['Kpi-Accesos-Ciudad-Coches'];
  const seriesData = configureDataValidate(
    resultSet,
    cleanData[0],
    kpiValidList,
    kpiInvalidList,
  );

  const specificOptions = {
    title: {
      text: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get('tituloGrafica')}`,
    },
    legend: {
      show: true,
      data: legendData,
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
    },
    yAxis: {
      name: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get(
        'unidadMedidaVehículos',
      )}`,
      axisLabel: {
        formatter: yAxisFormat,
      },
    },
    dataZoom: {
      show: true,
      data: xAxisData,
      start: datazoomStart,
    },
    toolbox: {
      show: true,
    },
  };

  configureLinesChartValidates(
    'chartAcessosCiutat',
    seriesData,
    specificOptions,
  );
}
export function echartAccessosCiutatPortada(vis, datos) {
  const color = COLORS.slice();
  const datosArray = datos.resultset || datos;

  // Obtenemos los datos ordenados
  const cleanData = configureDataLine(datosArray, color, false);
  const date = cleanData[1];
  const xAxisData = Array.from(date.values());
  const legendData = cleanData[2];

  // Obtenemos los datos para formar la serie
  const resultSet = resultsetWithFields(datos);
  const kpiValidList = [
    'KpiValid-30-Accesos-Ciudad-Coches',
    'KpiValid-365-Accesos-Ciudad-Coches',
  ];
  const kpiInvalidList = ['Kpi-Accesos-Ciudad-Coches'];

  const values = resultSet.map((item) => item.value);
  const maxValue = Math.max(...values);

  const seriesData = configureDataValidate(
    resultSet,
    cleanData[0],
    kpiValidList,
    kpiInvalidList,
  );

  const specificOptions = {
    grid: {
      left: '0',
      right: '0',
      bottom: '0',
      top: '200',
      containLabel: true,
    },
    title: {
      text: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get('tituloGrafica')}`,
    },
    legend: {
      show: true,
      data: legendData,
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      axisLabel: {
        margin: 15,
      },
    },
    yAxis: {
      name: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get(
        'unidadMedidaVehículos',
      )}`,
      axisLabel: {
        formatter: yAxisFormat,
      },
      max: maxValue,
    },
    dataZoom: {
      show: false,
    },
    toolbox: {
      show: false,
    },
  };

  configureLinesChartValidates(
    'chartTransitAccessosCiutat',
    seriesData,
    specificOptions,
  );
}
